import actions from "./actions";

const setIdempotencyKey = actions.setIdempotencyKey;
const clearIdempotencyKey = actions.clearIdempotencyKey;

export default {
  setIdempotencyKey,
  clearIdempotencyKey,
};
